export default "__VITE_ASSET__HaodpZpi__"